import { atom, selector } from 'recoil'

import { isNullOrEmpty } from 'Helpers/strings'
import type { ModalSubscribeState } from 'Pages/RecipientsList/model'

export const modalSubscribeState = atom<ModalSubscribeState>({
  key: 'recipientsList_modalSubscribeState',
  default: {
    show: false,
    idRecipient: 0,
    contactEmail: '',
    contactSMS: '',
    //
    lists: [],
    allLists: false,
    recipientSubscriptionLists: [],
    listsIsDirty: false,
    //
    channelEmail: false,
    channelSMS: false,
    sendConfirmation: false,
    idConfirmationMessage: 0,
    idConfirmationMessageIsDirty: false,
    forceSubscription: false,
  },
})

export const modalSubscribeIsSMSOnlyState = selector<boolean>({
  key: 'recipientsList_modalSubscribeIsSMSOnlyState',
  get: ({ get }) => {
    const { contactEmail, contactSMS } = get(modalSubscribeState)

    return !isNullOrEmpty(contactSMS) && isNullOrEmpty(contactEmail)
  },
})

export const modalSubscribeCanConfirmState = selector<boolean>({
  key: 'recipientsList_modalSubscribeCanConfirmState',
  get: ({ get }) => {
    const {
      channelEmail,
      channelSMS,
      allLists,
      lists,
      sendConfirmation,
      idConfirmationMessage,
    } = get(modalSubscribeState)

    return (
      (channelEmail || channelSMS) && //  almeno un canale selezionato
      (allLists || lists.length > 0) && // tutte le liste o almeno una lista
      (sendConfirmation ? idConfirmationMessage > 0 : true) //  se richiedi conferma, msg selezionato
    )
  },
})

export const modalSubscribeShowChannelsState = selector<boolean>({
  key: 'recipientsList_modalSubscribeShowChannelsState',
  get: ({ get }) => {
    const { contactEmail, contactSMS } = get(modalSubscribeState)

    return !isNullOrEmpty(contactEmail) && !isNullOrEmpty(contactSMS)
  },
})

export const modalSubscribeHasEmailChannel = selector<boolean>({
  key: 'recipientsList_modalSubscribeHasEmailChannel',
  get: ({ get }) => {
    const { contactEmail } = get(modalSubscribeState)

    return !isNullOrEmpty(contactEmail)
  },
})

export const modalSubscribeHasMessageFeedbackState = selector<boolean>({
  key: 'recipientsList_modalSubscribeHasMessageFeedbackState',
  get: ({ get }) => {
    const { idConfirmationMessage, idConfirmationMessageIsDirty } =
      get(modalSubscribeState)

    return (
      (idConfirmationMessage === undefined || idConfirmationMessage === null) &&
      idConfirmationMessageIsDirty
    )
  },
})
